import { render, staticRenderFns } from "./ManualRightSideBar.vue?vue&type=template&id=4325480c&scoped=true"
import script from "./ManualRightSideBar.vue?vue&type=script&lang=js"
export * from "./ManualRightSideBar.vue?vue&type=script&lang=js"
import style0 from "./ManualRightSideBar.vue?vue&type=style&index=0&id=4325480c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325480c",
  null
  
)

export default component.exports